"use client";

import {
  FC,
  useCallback,
  useEffect,
  useState,
} from "react";
import Link from "next/link";
import { themeRootClassMap } from "apps/website/maps/Theme.map";
import Button from "apps/website/components/base/Button/Button";
import { IButton } from "apps/website/components/base/Button/Button.map";
import Column from "apps/website/components/layout/Column/Column";
import Container from "apps/website/components/layout/Container/Container";
import Grid from "apps/website/components/layout/Grid/Grid";
import Section from "apps/website/components/layout/Section/Section";

import TextBody from "../../base/Text/TextBody/TextBody";

import { Display, displayClassMap, onHideClassMap } from "./CookieBar.map";

// This is a repeat, this is fine for a moment
declare global {
  interface Window {
    gtag: (...args: any[]) => void; // eslint-disable-line
  }
}

export interface ICookieBar {
  cta: IButton;
  display?: Display;
}

const CookieBar: FC<ICookieBar> = ({ cta, display = "default" }) => {

  const [ showCookieBanner, setShowCookieBanner ] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("acceptCookies") !== "true" && sessionStorage.getItem("rejectCookies") !== "true") {
      setShowCookieBanner(true);
    }
  }, [ showCookieBanner, setShowCookieBanner ]);

  const onConsentToCookies = useCallback(() => {

    if (typeof window === "undefined") { return; }

    if (!showCookieBanner) {
      if (typeof window === "undefined" || !window.gtag) { return; }

      window.gtag("consent", "update", {
        ad_storage: "granted",
        analytics_storage: "granted",
        functionality_storage: "granted",
        personalization_storage: "granted",
        security_storage: "granted",
        ad_user_data: "granted",
        ad_personalization: "granted",
      });
    }

  }, []);

  const rejectCookies = () => {
    setShowCookieBanner(false);
    sessionStorage.setItem("rejectCookies", "true");
  };

  const acceptCookies = () => {
    setShowCookieBanner(false);
    localStorage.setItem("acceptCookies", "true");
    onConsentToCookies();
  };

  useEffect(() => {
    if (localStorage.getItem("acceptCookies") === "true") {
      onConsentToCookies();
    }
  }, []);

  return (
    <Section
      component="CookieBar"
      size="none"
      className={`w-full z-40 transform duration-300 transition-all ${displayClassMap[display]} ${!showCookieBanner ? onHideClassMap[display] : "visible"}`}
    >
      <Container>
        <div className={` py-2 px-4 rounded-t-lg ${themeRootClassMap.dark}`} data-theme="dark" aria-hidden={!showCookieBanner}>
          <Grid>
            <Column direction="row" align="center" justify="center">
              <div className="flex flex-col">
                <TextBody tag="div" size={2} data-testid="CookieBar-body" className="pr-4">We use cookies. <Link href="/legal/privacy-policy" className="underline">Find out more</Link> on how we use them to give you a personalised browsing experience. Click <button onClick={rejectCookies} className="underline">here</button> to reject the use of cookies.</TextBody>
              </div>
              <Button
                onClick={acceptCookies}
                design={cta.design}
                color={cta.color}
                disabled={!showCookieBanner}
                data-testid="CookieBar-cta"
              >
                { cta.name }
              </Button>
            </Column>
          </Grid>
        </div>
      </Container>
    </Section>
  );
};

export default CookieBar;
